
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';


function Electricwork() {



  const cardData =
  {
    keyword: ' Electrical Work Services ',
    heading: 'Anjali Enterprises: Electrical Work Services ',
    headingDescription: 'Anjali Enterprises provides reliable and professional electrical work services in Pune, specializing in a wide range of electrical installations and solutions for residential, commercial, and industrial properties. Our team ensures safety, efficiency, and high-quality craftsmanship in every project.',

    "topPlaces": [
        {
          "title": "Electrical Wiring Installation",
          "description": "We offer expert electrical wiring installation services for homes, offices, and commercial buildings. Our team ensures proper wiring that meets safety standards, providing a reliable electrical system for your property."
        },
        {
          "title": "Commercial Electrical Services",
          "description": "Anjali Enterprises specializes in commercial electrical services, offering everything from installations to maintenance for businesses, offices, retail spaces, and industrial units. We ensure that your commercial property is equipped with a safe and efficient electrical system."
        },
        {
          "title": "Residential Electrical Work",
          "description": "Our residential electrical work covers all aspects of home wiring, lighting installations, panel upgrades, and more. We prioritize safety and efficiency to ensure that your home’s electrical system meets your needs."
        },
        {
          "title": "Electrical Panel Installation",
          "description": "We provide professional electrical panel installation services for residential and commercial properties. Our panels are designed to manage power distribution efficiently and safely, ensuring your electrical system operates smoothly."
        },
        {
          "title": "Electrical Maintenance Services",
          "description": "Regular maintenance is key to the longevity and reliability of electrical systems. Anjali Enterprises offers comprehensive electrical maintenance services, including inspections, repairs, and upgrades to ensure your system is always functioning at its best."
        },
        {
          "title": "Electrical Contractors Pune",
          "description": "As trusted electrical contractors in Pune, we offer expert electrical services for all types of properties. Our team is skilled in both new installations and system upgrades, ensuring your property’s electrical system is secure and efficient."
        },
        {
          "title": "Lighting Solutions",
          "description": "We provide innovative lighting solutions for residential, commercial, and industrial properties. From energy-efficient lighting to decorative fixtures, our services enhance the ambiance and functionality of any space."
        },
        {
          "title": "Electrical Repairs",
          "description": "Our electrical repair services include troubleshooting and fixing all types of electrical issues, from circuit malfunctions to faulty wiring. We offer prompt and efficient solutions to keep your electrical systems in top condition."
        },
        {
          "title": "Power Distribution Systems",
          "description": "We specialize in the design, installation, and maintenance of power distribution systems for residential, commercial, and industrial properties. Our solutions ensure the safe and efficient distribution of electricity throughout your building."
        },
        {
          "title": "Electrical Troubleshooting",
          "description": "Anjali Enterprises provides expert electrical troubleshooting services to identify and resolve electrical issues quickly. Whether you’re experiencing power outages or circuit issues, we ensure a thorough diagnosis and effective solution."
        },
        {
          "title": "Electrical Installations for Offices and Homes",
          "description": "From lighting to wiring and power outlets, we handle all types of electrical installations for both offices and homes. Our installations are designed for safety, efficiency, and ease of use."
        },
        {
          "title": "Anjali Enterprises Contact Number",
          "description": "Contact Anjali Enterprises at +91 8793220265 for reliable and high-quality electrical work. We specialize in all types of electrical services, including wiring, installation, maintenance, and troubleshooting for both residential and commercial properties. Get in touch for expert service, ensuring safety and efficiency in all electrical installations. Serving Pune with top-notch electrical work tailored to your specific needs."
        }
      ],
      "tableData": [
        ["- Electrical wiring installation", "- Commercial electrical services"],
        ["- Residential electrical work", "- Electrical panel installation"],
        ["- Electrical maintenance services", "- Electrical contractors Pune"],
        ["- Lighting solutions", "- Electrical repairs"],
        ["- Power distribution systems", "- Electrical troubleshooting"],
        ["- Electrical installations for offices and homes", "- Contact Anjali Enterprises for expert service"]
      ],


   "whychoose": [
  {
    "WhyChooseheading": "Comprehensive Electrical Services",
    "WhyChoosedescription": "At Anjali Enterprises, we provide a wide range of electrical services for both residential and commercial properties. Whether you need new installations, routine maintenance, urgent repairs, or system upgrades, we have the expertise and resources to handle all your electrical requirements. Our team is equipped to manage projects of all sizes, ensuring your electrical systems operate efficiently and safely."
  },
  {
    "WhyChooseheading": "Experienced and Certified Electricians",
    "WhyChoosedescription": "Our team consists of certified, highly skilled electricians who have years of hands-on experience in handling various electrical systems. Each member adheres to industry safety standards and best practices, ensuring that your electrical systems are in expert hands. Whether it's troubleshooting, repairs, or complex installations, we provide dependable and professional services that guarantee your systems work flawlessly."
  },
  {
    "WhyChooseheading": "Timely and Efficient Service",
    "WhyChoosedescription": "At Anjali Enterprises, we understand the urgency that often comes with electrical work. That's why we prioritize completing projects quickly and efficiently, ensuring minimal disruption to your daily activities. Whether it's an emergency repair or a scheduled installation, we make it our goal to finish on time without compromising on the quality of work. Our team is always ready to provide fast, effective service tailored to your needs."
  },
  {
    "WhyChooseheading": "Safety First",
    "WhyChoosedescription": "Safety is at the heart of everything we do. Our electricians are fully trained to follow the highest safety standards and use state-of-the-art tools and equipment. We never compromise on safety, whether we're working on simple installations or complex electrical systems. By strictly adhering to safety protocols, we ensure that both our team and your property are protected throughout the project, providing you with peace of mind."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "We offer competitive pricing on all our electrical services, ensuring you receive top-notch service without breaking the bank. Our pricing is completely transparent with no hidden charges or surprise costs. Before we begin any project, we provide clear, detailed estimates, so you know exactly what to expect. Our goal is to deliver high-quality electrical services that offer great value for your investment."
  },
  {
    "WhyChooseheading": "Residential and Commercial Electrical Work",
    "WhyChoosedescription": "Whether it's a residential home, office, or large-scale industrial space, we have the expertise to handle electrical work of any scale. From upgrading electrical panels to installing energy-efficient lighting systems, we provide tailored solutions to meet the unique needs of both residential and commercial clients. Our team is well-equipped to deliver reliable and safe electrical services for all types of properties."
  },
  {
    "WhyChooseheading": "Electrical Repairs and Troubleshooting",
    "WhyChoosedescription": "Electrical issues can cause major disruptions, and our team is here to resolve them quickly and efficiently. Whether you're dealing with faulty wiring, circuit breaker failures, or any other electrical issue, we have the skills to diagnose and fix the problem. Our electricians use the latest tools and technology to identify the source of the issue and provide quick, lasting repairs that restore your electrical system to optimal performance."
  },
  {
    "WhyChooseheading": "Energy-Efficient Solutions",
    "WhyChoosedescription": "We specialize in providing energy-efficient electrical solutions that can help lower your energy bills and promote sustainability. Our team is experienced in installing energy-efficient lighting, smart controls, and other systems designed to minimize energy consumption. We work with you to find the best solutions that not only save you money but also reduce your environmental impact by using green technologies and practices."
  },
  {
    "WhyChooseheading": "Quality Workmanship Guaranteed",
    "WhyChoosedescription": "At Anjali Enterprises, we take immense pride in delivering exceptional quality workmanship on every project we undertake. We use only the highest-quality materials and products to ensure the longevity and reliability of every electrical installation and repair. Our commitment to excellence means that you can trust us to deliver results that stand the test of time, no matter the size or complexity of the project."
  },
  {
    "WhyChooseheading": "Emergency Electrical Services",
    "WhyChoosedescription": "Electrical emergencies can happen at any time, and when they do, you need immediate assistance. Anjali Enterprises offers 24/7 emergency electrical services to handle urgent issues like power outages, electrical shorts, circuit breaker failures, and more. Our team is always on standby, ready to respond quickly and ensure the safety and functionality of your electrical systems. With our emergency services, you can rest assured that help is just a phone call away."
  }
]


  }

  const faqData = [
    {
      "question": "What electrical services do you offer?",
      "answer": "We offer a wide range of electrical services, including electrical installations, maintenance, repairs, panel upgrades, wiring, lighting installation, fault detection, and more for both residential and commercial properties."
    },
    {
      "question": "Are your electricians licensed and insured?",
      "answer": "Yes, all our electricians are fully licensed and insured. They are trained to follow all safety protocols, ensuring reliable and secure electrical work for your home or business."
    },
    {
      "question": "How do I know if I need electrical repairs?",
      "answer": "If you experience flickering lights, frequent circuit breaker trips, sparking outlets, or burning smells, it's time to call an electrician. These are signs of electrical issues that require immediate attention to prevent further damage or safety hazards."
    },
    {
      "question": "Do you provide electrical work for both homes and businesses?",
      "answer": "Yes, we provide electrical services for both residential and commercial properties. Whether it's wiring for a new home, installing office lighting, or handling electrical issues at an industrial site, we have the expertise to meet all your electrical needs."
    },
    {
      "question": "Can you help with energy-efficient lighting and electrical systems?",
      "answer": "Absolutely! We specialize in energy-efficient electrical solutions, including LED lighting, smart home systems, and other sustainable options that can reduce your energy consumption and lower your electricity bills."
    },
    {
      "question": "Do you provide emergency electrical services?",
      "answer": "Yes, we offer 24/7 emergency electrical services. If you face an electrical emergency, such as a power outage, short circuit, or electrical failure, our team is always ready to provide prompt assistance to restore your system."
    },
    {
      "question": "How much does electrical work cost?",
      "answer": "The cost of electrical work depends on the type and scope of the project. We provide free estimates for all electrical services, and our pricing is transparent, with no hidden charges."
    },
    {
      "question": "Can you help with electrical wiring and panel upgrades?",
      "answer": "Yes, we specialize in electrical wiring and panel upgrades. If you're renovating your space or need to meet modern electrical demands, we can upgrade your wiring and panel to accommodate additional load and ensure safety."
    },
    {
      "question": "Do you offer regular maintenance for electrical systems?",
      "answer": "Yes, we offer regular maintenance services to ensure your electrical systems remain in good condition. Regular maintenance can prevent issues and extend the lifespan of your electrical systems."
    },
    {
      "question": "Why should I choose Anjali Enterprises for electrical work?",
      "answer": "Anjali Enterprises is committed to providing high-quality, reliable, and affordable electrical services. Our team of certified electricians is experienced in handling a wide range of electrical tasks, and we prioritize safety, efficiency, and customer satisfaction in every project."
    }
  ];
  
  const testimonials = [
    {
      "name": "Mr. Abhishek Mehta",
      "text": "I hired Anjali Enterprises for some electrical upgrades in my home, and the team did an outstanding job. They were professional, efficient, and made sure everything was installed safely. Highly recommend them for any electrical work!"
    },
    {
      "name": "Ms. Radhika Sharma",
      "text": "We had an urgent electrical issue at our office, and Anjali Enterprises responded quickly. Their electricians identified and fixed the problem in no time, and we were back up and running. Excellent service!"
    }
  ];
  



  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>{testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: " Anjali Enterprises Contact Information:",
    contactNumbers: [
      "+91 8793220265",

    ],
    email: "info@anjalienterprisesindia.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "All Types of Aluminium Glass Office Partition",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "All Types of Toughened Glass Work",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Door Partition",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "ACP Cladding Panel Installation",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Aluminium Glass Window",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Soundproof Glass Window",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Aluminium Mosquito Net",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bird Net Installation",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Invisible Grill Installation",
    },
    {
      place: "/images/keyword/10.jpg",
      text: " MS Fabrication Door",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "MS Fabrication Shade",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "MS Fabrication Grill",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "MS Fabrication Slide Door ",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "MS Fabrication Industrial Shade",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "All Types of Industrial Fabrication Work",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "All Types of Furniture Work",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "All Types of Industrial Work",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "All Types of Home Renovation Work",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "All Types of Painting Work",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Foil Ceiling Work",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Electrical Work",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Puff Panel Room ",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "PCC Work & Epoxy Flooring Work ",
    },
  ];


  const images = [
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },

  ];



  return (
    <div>



<Helmet>
  <title> Electrical Work Services in Pune</title>
  <meta name="description" content="Anjali Enterprises offers electrical work services, electrical wiring installation, commercial and residential electrical work, electrical panel installation, maintenance, and more in Pune. Call +91 8793220265 for expert electrical solutions." />
  <meta name="keywords" content="Electrical Work Services, Electrical Wiring Installation, Commercial Electrical Services, Residential Electrical Work, Electrical Panel Installation, Electrical Maintenance Services, Electrical Contractors Pune, Lighting Solutions, Electrical Repairs, Power Distribution Systems, Electrical Troubleshooting, Electrical Installations for Offices and Homes" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8793220265 | Anjali Enterprises | Electrical Work Services in Pune" />
  <meta property="og:description" content="Anjali Enterprises offers electrical work services, electrical wiring installation, commercial and residential electrical work, electrical panel installation, maintenance, and more in Pune. Call +91 8793220265 for expert electrical solutions." />
  <meta property="og:image" content="https://anjalienterprisesindia.com/images/electrical-work-service.jpg" />
  <meta property="og:url" content="https://anjalienterprisesindia.com/electrical-work-services" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Anjali Enterprises" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Anjali Enterprises",
        "description": "Anjali Enterprises offers electrical work services, electrical wiring installation, commercial and residential electrical work, electrical panel installation, maintenance, and more in Pune. Call +91 8793220265 for expert electrical solutions.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8793220265",
        "email": "info@anjalienterprisesindia.com",
        "url": "https://anjalienterprisesindia.com/electrical-work-services",
        "logo": "https://anjalienterprisesindia.com/images/anjali-enterprises-logo.jpg",
        "image": "https://anjalienterprisesindia.com/images/electrical-work-service.jpg",
        "priceRange": "₹2000 - ₹15000",
        "offers": {
          "@type": "Offer",
          "url": "https://anjalienterprisesindia.com/electrical-work-services",
          "priceCurrency": "INR",
          "price": "2000",
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "45"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Ravi P"
            },
            "datePublished": "2024-07-01",
            "reviewBody": "The electrical work done by Anjali Enterprises was excellent. They installed new lighting and handled all wiring issues efficiently. Highly recommended for any electrical work!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Priya M"
            },
            "datePublished": "2024-08-25",
            "reviewBody": "We hired Anjali Enterprises for our new office electrical setup, and their team was very professional. The panel installation and maintenance were perfect. Great service!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Anjali Enterprises Service Area",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://anjalienterprisesindia.com/electrical-work-services"
        },
        "keywords": "Electrical Work Services, Electrical Wiring Installation, Commercial Electrical Services, Residential Electrical Work, Electrical Panel Installation, Electrical Maintenance Services, Electrical Contractors Pune, Lighting Solutions, Electrical Repairs, Power Distribution Systems, Electrical Troubleshooting, Electrical Installations for Offices and Homes"
      }
    `}
  </script>
</Helmet>


      {/* Banner */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="Service-banner-image" />
        <div className="banner-caption">
          <h1 className='text-white'>{cardData.keyword}</h1>
        </div>
      </div>



      <section>
        <div className="" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/21.jpg' className='img-fluid' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#24ABE2', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}

              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {/* {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))} */}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <h3 className='Colo'>Why Choose Anjali Enterprises for {cardData.keyword}  </h3>

              <div id="why-choose-section"
                className='px-2'>


                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>

              <div>
                <h3 className='Colo'>FAQs{cardData.keyword} for Anjali Enterprises</h3>
                <Accordion data={faqData} />
              </div>
              <div className=''>


                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>

              <div className='py-5'>

                <div className="contact-box borderrr py-md-3">
                  <h2>{contactData.heading}</h2>
                  <p>For inquiries, quotes, or assistance with your aluminium glass office partition needs, please contact us:</p>
                  <div className="contact-details">
                    <p><strong className=''>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5 darkcolor">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className=''>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link darkcolor">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >

              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>

                );
              })}










              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '1px solid #24ABE2',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                  color: 'white'
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#24ABE2' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8793220265 " className="d-block  text-white">+91 8793220265 </a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@anjalienterprisesindia.com" className=" text-white d-block">
                          info@anjalienterprisesindia.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i>

                            Anjali Enterprises:<br />
                            Shop No 7 Vishal Deep Residency M  <br />
                            Perk Nagar Highway, Chandan Nagar<br />
                            Vadgaon Sheri,  (Near NA Bus Stop) Pune <br />
                            Maharashtra 411014
                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <Gallery images={images} ></Gallery>

              </div>

            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Electricwork;